import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-student-usercompare-create",
  templateUrl: "./student-usercompare-create.component.html",
  styleUrls: ["./student-usercompare-create.component.scss"],
})
export class StudentUsercompareCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  userdata = [];



  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) { }

  public reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");

    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http
        .get<any>(`${environment.apiUrl}/usercompare/${id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data.data != "") {
              if (role != "super-admin" && data.data.userid != user) {
                this.router.navigateByUrl("/student-details/student-usercompare-list");
              }
              this.action = "Update";


              this.Form.patchValue({
                _id: data.data._id,
                college: data.data.college,


              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );

    });
    this.http
      .get<any>(`${environment.apiUrl}/userdata/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);

          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.userdata = data.results;
          // console.log(data.results[0].name);

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );

    this.Form = this.formBuilder.group({
      college: ["", [Validators.required]],
      userdata: ["", Validators.required],
      _id: [""],
    });

  }


  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        college: this.Form.value.college,
        "userdata": this.Form.value.userdata,


      };
      console.log(data);

      this.http
        .post<any>(`${environment.apiUrl}/usercompare/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(

          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/student-details/student-usercompare-list");
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    } else {
      let data = {
        college: this.Form.value.college,
        "userdata": this.Form.value.userdata,
        _id: this.Form.value._id,
      };
      this.http
        .put<any>(`${environment.apiUrl}/usercompare/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/student-details/student-usercompare-list");
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
}
